<template>
    <div class="row mb-4">
      <div class="col-xl-4 mx-auto text-center" style="display: flex; justify-content: center;">
        <div class="circle">
            <div class="dashed-circle"></div>
            <span class="circle-number">{{ ageAtRetirement }}</span>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getAgeAtRetirement } from '@/guiide/ts/utilities';

const ageAtRetirement = computed<string>(() => {
    const age = getAgeAtRetirement();
    return age == null ? null : age.toString();
});
</script>

<style>
  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #00aaa2;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    position: relative;
  }

  .dashed-circle {
    position: absolute;
    top: 5px;
    left: 5px;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    border: 2px dashed white;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .circle-number {
    color: white;
    font-size: 24px;
    font-weight: bold;
    z-index: 1;
  }
</style>